// extracted by mini-css-extract-plugin
export var animationContainer = "_i8-0";
export var footer = "_i8-1";
export var gray = "_i8-2";
export var lineItem = "_i8-3";
export var lineItemImage = "_i8-4";
export var lineItemInfo = "_i8-5";
export var lineItemText = "_i8-6";
export var lineItems = "_i8-7";
export var modalContent = "_i8-8";
export var options = "_i8-9";
export var orderName = "_i8-a";
export var refundAmount = "_i8-b";